import { login, getUserInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  userInfo: null,
  roles: []
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info
  },
  SET_ROLES(state, roles) {
    state.roles = roles
  }
}

const actions = {
  async login({ commit }, { phone, password }) {
    const res = await login({ phone, password })
    const data = res.data || res
    commit('SET_TOKEN', data.token)
    setToken(data.token)
    return data
  },
  async getUserInfo({ commit }) {
    const res = await getUserInfo()
    const data = res.data || res
    commit('SET_USER_INFO', data)
    // 角色映射：1-消费者 2-商户 3-商场运营 4-平台管理员
    const roleNames = ['', 'consumer', 'merchant', 'operator', 'admin']
    commit('SET_ROLES', [roleNames[data.role] || 'consumer'])
  },
  logout({ commit }) {
    commit('SET_TOKEN', null)
    commit('SET_USER_INFO', null)
    commit('SET_ROLES', [])
    removeToken()
  }
}

export default { namespaced: true, state, mutations, actions }